import { render, staticRenderFns } from "./AdminClinic.vue?vue&type=template&id=2735bf2f"
import script from "./AdminClinic.vue?vue&type=script&lang=js"
export * from "./AdminClinic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports